import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import BioentityChip from 'ui-library/chips/BioentityChip';
import {ChipSize} from 'ui-library/chips/Chip';
import * as LoadingScreen from 'ui-library/LoadingScreen';
import Modal from 'ui-library/modals/Modal';

export interface ComplexPolymerRemoveConjugateWarningModalProps {
  onRequestClose: () => void;
  onRemoveConjugate: () => Promise<void>;
  entityId: string;
  complexPolymerName: string;
}

export default function ComplexPolymerRemoveConjugateWarningModal({
  onRequestClose,
  onRemoveConjugate,
  complexPolymerName,
  entityId,
}: ComplexPolymerRemoveConjugateWarningModalProps): JSX.Element {
  const buttons = [
    {
      text: 'Remove conjugate',
      disabled: false,
      submit: true,
    },
  ];

  return (
    <Modal
      title="Remove conjugate"
      medium={true}
      buttons={buttons}
      onRequestClose={onRequestClose}
      scrollable={false}
      onRequestSubmit={async () => {
        LoadingScreen.show(`Updating oligo conjugate...`);

        try {
          await onRemoveConjugate();
        } finally {
          onRequestClose();
          LoadingScreen.hide();
        }
      }}
    >
      <div className={css(styles.bodyContainer)}>
        <span>
          You are about to remove <BioentityChip id={entityId} isLink={false} size={ChipSize.MINI} /> from{' '}
          {complexPolymerName}. This action will remove all drawn connections associated with this entity.
        </span>
        <span>Are you sure this is what you want to do?</span>
      </div>
    </Modal>
  );
}

const styles = StyleSheet.create({
  pageContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflowY: 'scroll',
  },
  bodyContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
});
